/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotEqualKeyPublicPem: core.serialization.ObjectSchema<
    serializers.NotEqualKeyPublicPem.Raw,
    Truvity.NotEqualKeyPublicPem
> = core.serialization.object({
    value: core.serialization.string(),
});

export declare namespace NotEqualKeyPublicPem {
    export interface Raw {
        value: string;
    }
}
